/** A colour scheme a token can resolve in. */
export type ColorScheme = 'light' | 'dark'

/** The colour a design token (such as `--color-accent-blue`) resolves to in one scheme, as a computed colour such as `rgb(0, 138, 255)`. */
export function resolveTokenColor(token: `--${string}`, scheme: ColorScheme): string {
  const probe = document.createElement('span')
  probe.hidden = true
  probe.style.colorScheme = scheme
  probe.style.color = `var(${token})`
  document.body.append(probe)
  const color = getComputedStyle(probe).color
  probe.remove()
  return color
}
